<template>
  <v-btn
    :color="type"
    :depressed="depressed"
    :disabled="disabled"
    :outlined="secondaryButton"
    :ripple="ripple"
    :text="tertiaryButton"
    :small="compact"
    :class="buttonClass"
    :height="compact ? '36px': '48px'"
    @click="$emit('click')"
    class="pl-7 pr-7"
  >
    <slot name="default">
      <v-icon
        v-if="icon"
        :class="{'material-icons-outlined':iconOutlined}"
      >
        {{ icon }}
      </v-icon>
      <span :class="icon ? 'pl-2':'pl-0'">{{ buttonText }}</span>
    </slot>
  </v-btn>
</template>
<script>
  export default {
      name: "AdsButton",
      props: {
        buttonText: {
          type: String,
          default: "Button"
        },
        type: {
          type: String,
          default: 'primary'
        },
        depressed: {
          type: Boolean,
          default: false
        },
        disabled: {
          type: Boolean,
          default: false
        },
        secondary: {
          type: Boolean,
          default: false
        },
        ripple: {
          type: Boolean,
          default: true
        },
        icon: {
          type: String,
          default: null
        },
        buttonClass: {
          type: String,
          default: null
        },
        tertiary: {
          type: Boolean,
          default: false
        },
        iconOutlined: {
          type: Boolean,
          default: true
        },
        compact: {
          type: Boolean,
          default: false
        }
      },
      computed:{
        secondaryButton() {
          if (!this.tertiary && this.secondary) {
            return true;
          }
          return false
        },
        tertiaryButton() {
          if (this.tertiary && !this.secondary) {
            return true;
          }
          return false;
        }
      }
}
</script>
<style lang='scss' scoped>
</style>